// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';
import ShowImg from '../components/ShowImg';

// img
import singleDownloadImg from '../img/download_img.png';
import figureImg from '../img/Figure_S2.png';

function Gaap04(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title"><em>De novo</em> assembly </h2>
            <h2 className="content_title2">Transcriptome assembly</h2>
            <div className="content_text">
                GAAP uses Trinity, based on the De Bruijn graph method, 
                which generally shows relatively good performance.
            </div><br/>
            <div className="content_command_title">Trinity</div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="http://trinityrnaseq.github.io" />
                    <br/>
                </div>
            </div><br/>
            <li className="content_description">Trinity Command</li>
            <CommandBox lines={[
                {data:
                    `Trinity --seqType fq --max_memory 50G --left RNAread_1.fq 
                    --right RNAread_2.fq --SS_lib_type FR`
                },
            ]}
            /><br/>
            <li className="content_description">Options for Trinity</li>
            <OptionTable
                data={[
                    {   option:'--seqType',
                        desc:'specify the format of the read data (fq for fastq, fa for fasta)'},
                    {   option:'--SS_lib_type',
                        desc:'specify the direction of the reads (F is forward, R is reverse)'},
                    {   option:`--max_memory`,
                        desc:'specify the maximum memory size'},   
                ]}
            /><br />
            <li className="content_description">Output of Trinity</li>
            <div className="content_text">
                trinity.fasta: stores the assembled transcript identifiers, lengths, paths in the De Bruijn 
                graphs corresponding to the transcripts, and transcript sequences&nbsp;
                <ShowImg name="(Supplementary Figure S2)"
                        src= {figureImg}
                />.
            </div><br/>
            <div className="content_buttons_div">
                <Link to="/Gaap03_Gap"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap05"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap04;